/**
 * Blood Test comparison — mobile column switch.
 *
 * The table renders all three columns; below the lg breakpoint only the feature
 * column plus ONE comparison column is visible, chosen by these tabs. The visibility
 * itself is CSS, driven by `data-active-column` on the root — this module only moves
 * that attribute and keeps ARIA in sync.
 *
 * Contract:
 *   [data-blood-test-comparison]      root, carries data-active-column
 *     [data-comparison-tab="<key>"]   <button role="tab">
 */

const COLUMNS = ['standard', 'tenx'];

function initOne(root) {
  const tabs = [...root.querySelectorAll('[data-comparison-tab]')];
  if (tabs.length === 0) return null;

  const select = (key) => {
    if (!COLUMNS.includes(key)) return;
    root.dataset.activeColumn = key;
    tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', String(tab.dataset.comparisonTab === key));
    });
  };

  const onClick = (e) => select(e.currentTarget.dataset.comparisonTab);

  // Left/Right arrows move between tabs, per the WAI-ARIA tabs pattern.
  const onKeydown = (e) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const i = tabs.indexOf(e.currentTarget);
    const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    next.focus();
    select(next.dataset.comparisonTab);
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', onClick);
    tab.addEventListener('keydown', onKeydown);
  });

  select(root.dataset.activeColumn || 'tenx');

  return {
    destroy() {
      tabs.forEach((tab) => {
        tab.removeEventListener('click', onClick);
        tab.removeEventListener('keydown', onKeydown);
      });
    },
  };
}

export default function initBloodTestComparisonTabs(scope) {
  const root = scope && scope.querySelectorAll ? scope : document;
  const instances = [...root.querySelectorAll('[data-blood-test-comparison]')]
    .map(initOne)
    .filter(Boolean);

  return {
    destroy() {
      instances.forEach((i) => i.destroy());
    },
  };
}
